import { AlertCircle, Loader2 } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface LandingPageErrorProps {
  message: string;
  onRegenerate: () => void;
  regenerating: boolean;
}

export function LandingPageError({ message, onRegenerate, regenerating }: LandingPageErrorProps) {
  return (
    <div className="space-y-4">
      <div className="border-l-4 border-[#FCA5A5] bg-[#FEE2E2] text-[#B91C1C] p-4">
        <div className="flex items-start gap-2">
          <AlertCircle className="h-5 w-5 shrink-0 mt-0.5" />
          <div>
            <h3 className="font-semibold mb-1">Generation Failed</h3>
            <p className="text-sm">{message}</p>
          </div>
        </div>
      </div>
      <Button
        onClick={onRegenerate}
        disabled={regenerating}
        className="h-9 bg-[#290BD9] hover:bg-[#2309C5] text-white"
      >
        {regenerating ? (
          <>
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
            Starting...
          </>
        ) : (
          'Regenerate'
        )}
      </Button>
    </div>
  );
}
